export function formatFileSize(kb = 0, decimals = 1) {
  if (kb === 0) {
    return "0 KB";
  }

  const mb = kb / 1024;

  const format = (value, unit) => {
    const isInteger = Number.isInteger(value);

    return isInteger
      ? `${value} ${unit}`
      : `${value.toFixed(decimals)} ${unit}`;
  };

  if (mb >= 1) {
    return format(mb, "MB");
  }

  return format(kb, "KB");
}

export function downloadFile(blob, fileName) {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName || "document");

  document.body.appendChild(link);

  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
}

export function viewFile(blob) {
  const url = window.URL.createObjectURL(new Blob([blob], { type: blob.type }));
  window.open(url, "_blank");
}
